import { render, staticRenderFns } from "./PaymentIssueFlags.vue?vue&type=template&id=af6cc886&scoped=true&"
import script from "./PaymentIssueFlags.vue?vue&type=script&lang=js&"
export * from "./PaymentIssueFlags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6cc886",
  null
  
)

export default component.exports